import React, { Component } from "react";
import htmlParser from "html-react-parser";
import styles from "./ArticleTemplate.module.scss";
import classes from "../KnowledgeCenter/KnowledgeCenter.module.scss";
import relatedStyles from "../../sections/NewsV2/News.module.scss";
import withHistory from "../../../src/HOCs/withHistory";
import {
  ADVANCING_INDEPENDENCE,
  API_URL,
  ARTICLE_DETAIL,
  ARTIST_LIKE_YOU,
  KNOWLEDGECENTER,
  LEARN_MORE,
  RELATED_CATEGORY_ARTICLES,
} from "../../routes/constants";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/pagination";
import { ReactComponent as IconChevron } from "../../assets/SVGs/double-chevron-right.svg";
import { ReactComponent as IconChevronUp } from "../../assets/SVGs/chevron-up-white.svg";
import { ReactComponent as IconChevronDown } from "../../assets/SVGs/chevron-down-white.svg";
import { ReactComponent as IconChevronLeft } from "../../assets/SVGs/chevron-left.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { HOMEPAGE_DEFAULT_CATEGORY } from "../ArticlePage/constant";
import { Button2, Divider, HelmetR, SnapSection } from "../../components";
import { get } from "lodash";
import { withRouter } from "../../routes/withRouter";
import Slider from "react-slick";
import SASS from "../../sass/_exports.scss";
import { ArticleCard } from "../ArticlePage/helper";

class ArticleTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParam: "",
      articleData: {},
      categoryFromArticle: "",
      list: [],
      loader: false,
      mainLoader: false,
      type: "",
    };
  }

  componentDidMount() {
    this.updateArticle();
  }

  componentDidUpdate(prevProps) {
    if (
      get(prevProps, "params.article_id") !==
        get(this.props, "params.article_id") ||
      get(prevProps, "params.name") !== get(this.props, "params.name") ||
      get(prevProps, "params.*") !== get(this.props, "params.*")
    ) {
      this.updateArticle();
    }
  }

  updateArticle = () => {
    const articleId = get(this.props, "params.article_id");
    const name = `${get(this.props, "params.name")}/${get(
      this.props,
      "params.*"
    )}`;
    this.setState(
      {
        type: get(this.props, "params.name") ? "name" : "articleId",
        searchParam: get(this.props, "params.name") ? name : articleId,
      },
      () => {
        this.getArticleData();
      }
    );
  };

  getArticleData = () => {
    const requestUrl = `${API_URL}${ARTICLE_DETAIL}?${
      this.state.type === "name" ? "name" : "id"
    }=${this.state.searchParam}`;
    this.setState({ mainLoader: true });
    axios
      .get(requestUrl)
      .then((res) => {
        this.setState(
          {
            articleData: res.data.data,
            totalPage: res.data.totalPages,
            total: res.data.total,
            mainLoader: false,
            categoryFromArticle: res?.data?.data?.category,
          },
          this.getListData
        );
      })
      .catch((err) => {
        this.setState({ mainLoader: false });
        window.location.pathname = KNOWLEDGECENTER;
      });
  };
  getListData = () => {
    const requestUrl = `${API_URL}${RELATED_CATEGORY_ARTICLES}?id=${get(
      this.state,
      "articleData._id"
    )}&limit=6&page=1&category=${this.state.categoryFromArticle}&sort=-publishDate&type=all`;
    this.setState({ loader: true });
    axios
      .get(requestUrl)
      .then((res) => {
        this.setState({
          list: res.data.data,
          totalPage: res.data.data.totalPages,
          total: res.data.data.total,
          loader: false,
        });
      })
      .catch((err) => {
        this.setState({ loader: false });
        console.error(err);
      });
  };
  colorAccToCategory = (category) => {
    switch (category) {
      case HOMEPAGE_DEFAULT_CATEGORY[1]:
        return styles.color1;
      case HOMEPAGE_DEFAULT_CATEGORY[2]:
        return styles.color2;
      case HOMEPAGE_DEFAULT_CATEGORY[3]:
        return styles.color3;
      case HOMEPAGE_DEFAULT_CATEGORY[4]:
        return styles.color4;
      case HOMEPAGE_DEFAULT_CATEGORY[0]:
        return styles.color5;
      default:
        break;
    }
  };

  renderTags = (list) => {
    return (
      list &&
      list.tag &&
      list?.tag?.length &&
      list.tag.map((tag, i) => (
        <>
          <Link
            className={styles.link}
            to={`${KNOWLEDGECENTER}/${encodeURIComponent(tag)}`}
          >
            {tag}
          </Link>
          <div>{list.tag.length !== i + 1 ? "," : ""}</div>
        </>
      ))
    );
  };


  renderNewList = (e, i) => {
    switch (e.type) {
      case "Articles":
        return <ArticleCard light list={e} i={i} marginTop />;
      default:
    }
  };

  getNewsId = () => {
    const related = get(
      this.state,
      "articleData._id"
    );
    return related;
  };

  getCategoryLink = (category) => {
    if (category === "Advancing Independence") {
      return ADVANCING_INDEPENDENCE;
    }
    if (category === "Artists Like You") {
      return ARTIST_LIKE_YOU;
    }
    if (category === "Learn More") {
      return LEARN_MORE;
    }
    return KNOWLEDGECENTER;
  };

  renderListByCategory = (list = [], loader) => (
    <div className={relatedStyles.carouselContainer}>
      <Slider
        //dots={true}
        infinite={false}
        slidesToShow={3}
        slidesToScroll={3}
        nextArrow={<IconChevronUp />}
        prevArrow={<IconChevronDown />}
        responsive={[
          {
            breakpoint: parseInt(SASS.MD_N),
            settings: { slidesToShow: 1.2, slidesToScroll: 1 },
          },
          {
            breakpoint: parseInt(SASS.LG_XL_N),
            settings: { slidesToShow: 2, slidesToScroll: 2 },
          },
        ]}
      >
        {!loader ? (
          list?.length > 0 &&
          list.map((value, index) => <>{this.renderNewList(value, index)}</>)
        ) : (
          <div className={classes.emptyDiv}>
            <FontAwesomeIcon icon={faCircleNotch} className="spin" />
          </div>
        )}
        {list?.length === 0 && (
          <div className={classes.emptyDiv}>
            <h1>No data</h1>
          </div>
        )}
      </Slider>
    </div>
  );

  render() {
    return (
      <>
        {this.state.articleData && <HelmetR data={this.state.articleData} />}
        <SnapSection>
          <div className={styles.articleTemplateContainer}>
            <div className={styles.pageTitleBack}></div>
            <div className={styles.goBackCtn}>
              <Button2 white xl tertiary onClick={() => this.props.navigate(-1)} className={styles.goBackBtn}><IconChevronLeft /><p>Go Back</p></Button2>
            </div>
            <div className={styles.articleMainContainer}>
              {!this.state.mainLoader ? (
                <div className={styles.articleContainer}>
                  <div className={styles.imgContainer}>
                    <img alt="-" src={this.state.articleData?.image} />
                  </div>
                  <Divider height="3px"/>
                  <div className={styles.articleDetailCtn}>
                    <h2 className={styles.author}> {this.state.articleData?.author}</h2>
                    <Divider height="3px" purple />
                    <h1>{this.state.articleData?.title}</h1>
                    <div className={styles.articleContent}>
                      {htmlParser(
                        this.state.articleData?.body
                          ? this.state.articleData?.body
                          : ""
                      )}
                    </div>
                    <div className={styles.metaCtn}>
                      <div className={styles.dateContainer}>
                        <span>Published {this.state.articleData?.publishDate
                            ? moment(this.state.articleData.publishDate).format(
                                "MMMM DD, YYYY"
                              )
                            : "-"}</span>
                        {get(this.state, "articleData.sourceUrl", false) ? (
                          <span>
                            |&nbsp;&nbsp;
                            <a href={this.state.articleData?.sourceUrl}>
                              Original Source
                            </a>
                          </span>
                        ):("")}
                        
                      </div>
                      <div className={styles.categoryContainer}>
                        <span>Category: </span>
                        <span>
                          <Link
                            className={styles.link}
                            to={this.getCategoryLink(this.state.articleData?.category)}
                          >
                            {this.state.articleData?.category}
                          </Link>
                        </span>
                      </div>
                      <div className={styles.tagsContainer}>
                        <span>Tags: </span>
                        <span>
                          {this.state.articleData?.tag?.length &&
                            this.state.articleData.tag.map((tag, i) => (
                              <>
                                <Link
                                  className={styles.link}
                                  to={`${KNOWLEDGECENTER}/${encodeURIComponent(
                                    tag
                                  )}`}
                                >
                                  {tag}
                                </Link>

                                <div>
                                  {this.state.articleData.tag.length !== i + 1
                                    ? ","
                                    : ""}
                                </div>
                              </>
                            ))}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.spin}>
                  <FontAwesomeIcon icon={faCircleNotch} className="spin" />
                </div>
              )}
            </div>
          </div>
        </SnapSection>
        <SnapSection>
          <div className={`${relatedStyles.NewsContainer} ${relatedStyles.light}`}>
            <div className={`${relatedStyles.subContainer}`}>
              <div className={relatedStyles.titleContainer}>
                <div className={`${relatedStyles.title}`}>
                  <h3 className={relatedStyles.heading}>Related Content</h3>
                </div>
                <Button2 light tertiary to={KNOWLEDGECENTER} className={relatedStyles.lnkBtnAll}><p>View&nbsp;All</p><IconChevron /></Button2>
              </div>
              {this.renderListByCategory(this.state.list, this.state.loader)}
            </div>
          </div>
        </SnapSection>
      </>
    );
  }
}

export default withHistory(withRouter(ArticleTemplate));
